<template>
  <div class="admin-wrapper">
    <!-- Soit on utilise AdminLayout, soit on laisse router-view afficher le layout -->
    <!-- Ion utilise AdminLayout qui contient déjà router-view -->
    <AdminLayout />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AdminLayout from '@/components/admin/AdminLayout.vue'; // Ajuste le chemin selon l'emplacement réel

export default defineComponent({
  name: 'AdminView',
  components: {
    AdminLayout
  }
});
</script>

<style lang="scss" scoped>
.admin-wrapper {
  min-height: 100vh;
  background-color: #f4f7fa;
}
</style>